import React from "react";

function ForgotPassword(props: any) {
  return <div>forgot password</div>;
}

export default ForgotPassword;
